// extracted by mini-css-extract-plugin
export default {"making-content-upload-tip-text":"making-content-upload-tip-text___YS3o1"};